export default {
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  SHOW_HIED_FORM_RESET_PASSWORD: "SHOW_HIED_FORM_RESET_PASSWORD",
  RETSET_PASSWORD: "RETSET_PASSWORD",
  RETSET_PASSWORD_SUCCESS: "RETSET_PASSWORD_SUCCESS",
};
